import { httpApi } from '@api/http.api';

export interface ConsentItem {
    id: number;
    title: string;
    description: string;
    lastModifiedUTC: string | null;
    createdAtUTC: string | null;
    isBuiltIn: boolean;
    isActive: boolean;
    wasAdded?: boolean;
    wasEdited?: boolean;
}

export interface ConsentItemRequest {
    id: number | null;
    title: string;
    description: string;
    isActive: boolean;
}

export interface UpdateConsentRequest {
    consents: ConsentItemRequest[];
}

export type ConsentDataResponse = ConsentItem[];

export const getApiConsent = (clientId: number, tenantAlias: string): Promise<ConsentDataResponse> =>
    httpApi
        .get<ConsentDataResponse>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/consents`)
        .then(({ data }) => data);

export const updateApiConsent = (clientId: number, tenantAlias: string, payload: UpdateConsentRequest): Promise<any> =>
    httpApi
        .put<any>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/consents`, payload)
        .then(({ data }) => data);
